import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ICashOutRequest } from 'src/app/shared/interfaces/cashOutRequest';
import { ICashRequestInp } from 'src/app/shared/interfaces/cashRequestInp';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-financial-requests',
  templateUrl: './financial-requests.component.html',
  styleUrl: './financial-requests.component.css'
})
export class FinancialRequestsComponent implements OnInit {

  requestList: ICashOutRequest[];
  cashReqInp: ICashRequestInp = {
    timeType: 2,
    price: 0
  }

  @ViewChild('modal') modal!: ModalComponent;

  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
  ){}

  ngOnInit(): void {
    this.getRequestsList();
  }


  getRequestsList() {
    const body = {
      title: '',
      pageIndex: 1,
      pageSize: 10,
    }
    this.apiService.apiCall('post', '/api/User/GetAllUserCashOutRequest', body).subscribe((res: any) => {
      console.log(res);
      
      this.requestList = res.body.model;
    })
  }

  sendRequest() {
    this.apiService.apiCall('post', '/api/User/AddCashOutRequest', this.cashReqInp).subscribe((res: any) => {
      console.log(res);

      if (res.body.isSuccess == true) {
        this.modal.close();
        
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'درخواست شما با موفقیت ثبت شد.' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }
}
